import React from 'react'
import './index.module.scss'
import TechnologyAnimate from './TechnologyAnimate'
export default function Technology() {
  return (
    <div style={{ width: '100%', height: 940, margin: 'auto', background: '#fff' }}>
      <div style={{ width: 1200 , margin: 'auto', textAlign: 'center' }}>
        <h2>数据中台技术<p></p></h2>
        <div style={{ marginTop: 100 }}>
          <TechnologyAnimate />
        </div>
      </div>
    </div>
  )
}
